<template>
  <div id="userActivateWrapper">

    <article v-if="activated" class="message is-success">
      <div class="message-header">
        <p>Geslaagd</p>
        <button class="delete" aria-label="delete"></button>
      </div>
      <div class="message-body">
        Uw account is geactiveerd. U kunt nu inloggen met de door u ingevoerde gegevens op <router-link :to="{ name: 'signin' }">deze</router-link> plek.
      </div>
    </article>

    <article v-else class="message is-danger">
      <div class="message-header">
        <p>Er ging is mis</p>
        <button class="delete" aria-label="delete"></button>
      </div>
      <div class="message-body">
        Het activeren van uw account is niet gelukt. Controleer de link en probeer het nogmaals of neem contact op met de beheerder.
      </div>
    </article>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      activated: false,
    }
  },
  created () {
    this.activate()
  },
  methods: {
    activate () {
      axios.get(
        `/auth/signup/activate/${this.$route.params.token}`
      ).then(
        this.activated = true
      ).catch(
        (err) => {
          console.log(err)
        }
      )
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/users/UserActivate.vue